import React from 'react';
import CoreLoadingIndicator from '../../loading-indicator/index';
import { TEXT_ROW_ITEM_BLOCK_NAME } from './constants';

/**
 * This is just a wrapper of a component. It is based on a vanilla LoadingIndicator component
 * More information about the methods, refer to the core of the vanilla component
 *
 * @return {React} React component
 */
class LoadingIndicator extends React.Component {

    constructor (props) {
        super(props);
    }

    componentDidMount() {
        const LoadingIndicator = new CoreLoadingIndicator();
        this.rootEl.appendChild(LoadingIndicator.el);
    }

    render () {
        return (
            <div className={ TEXT_ROW_ITEM_BLOCK_NAME } ref={icon => { this.rootEl = icon; }}>
            </div>
        );
    }
}

export default LoadingIndicator;
